// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__26R60","header":"ClearentDisclaimer_header__2I1_9","inner":"ClearentDisclaimer_inner__eUb2k"};